import { defineProperty as _defineProperty } from '../../../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { Button } from '@deal/components';
import { usePathContext } from '../../../../../context/PathContext.js';
import classNames from 'classnames';
import retirevePreviousNode from '../../../../../helpers/retrievePreviousNode.js';
import PlainText from '../../../../../components/PlainText/index.js';
import styles from './styles.css.js';

var ContinueButtonProgression = function ContinueButtonProgression(_ref) {
  var continueProgression = _ref.continueProgression,
      loading = _ref.loading,
      onSubmit = _ref.onSubmit,
      isBackVisible = _ref.isBackVisible;

  var _a;

  var pathContext = usePathContext();
  var previousNode = retirevePreviousNode(pathContext.pathGraphFlow, (_a = pathContext.activeNode) === null || _a === void 0 ? void 0 : _a.id);
  return React.createElement("div", {
    className: classNames(styles.actions, _defineProperty({}, styles.placementModal, pathContext.pathPlacement === 'modal'))
  }, previousNode && isBackVisible && React.createElement("div", {
    className: styles.backButton
  }, React.createElement(Button, {
    disabled: loading,
    type: "button",
    size: "large",
    variant: "default-ghost",
    tabIndex: 2,
    onClick: function onClick() {
      return pathContext.onSetActiveNode(previousNode);
    }
  }, "Back")), React.createElement("div", {
    className: styles.submitButton
  }, React.createElement(Button, {
    disabled: loading,
    type: "submit",
    size: "large",
    tabIndex: 1,
    onClick: function onClick() {
      return onSubmit();
    }
  }, continueProgression.continueButtonText ? React.createElement(PlainText, {
    plainTextEntry: continueProgression.continueButtonText
  }) : 'Continue')));
};

export default ContinueButtonProgression;
//# sourceMappingURL=index.js.map
